module.exports = __webpack_public_path__ + "static/media/shower-rain.c6e84204.gif";